module.exports = __webpack_public_path__ + "static/media/redux.79e89386.png";